import { Dialog, DialogContent } from "@mui/material";
import React from "react";

const CancelPopup = ({
  openCancel,
  onClose,
  handleAdminReject,
  selectedAlertId,

}) => {


  return (
    <Dialog
      open={openCancel}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: "20px" },
      }}
    >
      <DialogContent>
        <div className="popup-accept-reject-div">
          <h3 className="delete-img-heading">Are you sure?</h3>
          <p className="delete-img-p">Do you really want to Reject?</p>
         
          <div className="delete-btn-div">
            <button
              onClick={() => {
              
                  handleAdminReject(selectedAlertId, "Cancelled");
                  onClose();
              }}
            >
              Reject
            </button>
            <button onClick={onClose}>Cancel</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CancelPopup;
